'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Functions = require('../core/Functions');

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UILink = require('../link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  // These do not come from the sketch file
  default: 'tag-default private-tag--disabled private-tag--default',
  primary: 'tag-primary private-tag--disabled',
  info: 'tag-info private-tag--info',

  disabled: 'private-tag--disabled',
  success: 'tag-success private-tag--success',
  warning: 'tag-warning private-tag--warning',
  danger: 'tag-danger private-tag--danger',

  calypso: 'private-tag--calypso',
  sorbet: 'private-tag--sorbet',
  lorax: 'private-tag--lorax',
  marigold: 'private-tag--marigold',
  'candy-apple': 'private-tag--candy-apple',
  norman: 'private-tag--norman',
  thunderdome: 'private-tag--thunderdome',
  oz: 'private-tag--oz',
  olaf: 'private-tag--olaf',

  'chart-red': 'private-tag--chart-red',
  'chart-orange': 'private-tag--chart-orange',
  'chart-yellow': 'private-tag--chart-yellow',
  'chart-green': 'private-tag--chart-green',
  'chart-aqua': 'private-tag--chart-aqua',
  'chart-blue': 'private-tag--chart-blue',
  'chart-purple': 'private-tag--chart-purple',
  'chart-dark-purple': 'private-tag--chart-dark-purple'
};

var STATUS_ALIAS_MAP = {
  paused: 'disabled',
  draft: 'disabled',
  active: 'success',
  sent: 'success',
  published: 'success',
  inReview: 'warning',
  scheduled: 'warning',
  removed: 'danger',
  cancelled: 'danger',
  error: 'danger'
};

var UITag = _react2.default.createClass({
  displayName: 'UITag',

  propTypes: {
    children: _react.PropTypes.any,
    className: _react.PropTypes.string,
    closeable: _react.PropTypes.bool.isRequired,
    href: _react.PropTypes.string,
    target: _react.PropTypes.string,
    inline: _react.PropTypes.bool.isRequired,
    multiline: _react.PropTypes.bool.isRequired,
    onClick: _react.PropTypes.func,
    onCloseClick: _react.PropTypes.func,
    style: _react.PropTypes.object,
    truncateStringProps: (0, _passthroughProps2.default)(_UITruncateString2.default),
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES).concat(Object.keys(STATUS_ALIAS_MAP))).isRequired,
    _avatar: _react.PropTypes.node, // for UIAvatarTag
    _bordered: _react.PropTypes.bool, // for MultiSelect
    _onCloseMouseDown: _react.PropTypes.func // for MultiSelectValue
  },

  getDefaultProps: function getDefaultProps() {
    return {
      _bordered: false,
      closeable: false,
      inline: false,
      multiline: false,
      use: 'default'
    };
  },
  getClassName: function getClassName(_ref) {
    var _bordered = _ref._bordered,
        className = _ref.className,
        closeable = _ref.closeable,
        inline = _ref.inline,
        use = _ref.use;

    var computedUse = STATUS_ALIAS_MAP[use] || use;
    return (0, _reactUtils.classNames)('tag', 'private-tag', className, USE_CLASSES[computedUse], {
      'private-tag--bordered': _bordered,
      'private-tag--has-close': closeable,
      'private-tag--inline': inline
    });
  },
  handleCloseClick: function handleCloseClick(evt) {
    var onCloseClick = this.props.onCloseClick;

    (0, _Functions.callIfPossible)(onCloseClick, evt);
  },
  renderCloseButton: function renderCloseButton(_ref2) {
    var closeable = _ref2.closeable;

    if (closeable) {
      return _react2.default.createElement(_UICloseButton2.default, {
        className: 'private-tag__close',
        onClick: this.handleCloseClick,
        onMouseDown: this.props._onCloseMouseDown
      });
    }

    return null;
  },
  renderContents: function renderContents(_ref3, _ref4) {
    var href = _ref3.href,
        target = _ref3.target,
        onClick = _ref3.onClick;
    var truncatedChildren = _ref4.truncatedChildren;

    var buttonClassName = 'private-tag__link';
    if (href) {
      return _react2.default.createElement(
        _UILink2.default,
        { className: buttonClassName, href: href, target: target },
        truncatedChildren
      );
    } else if (onClick) {
      return _react2.default.createElement(
        _UIClickable2.default,
        { className: buttonClassName, onClick: onClick },
        truncatedChildren
      );
    }

    return _react2.default.createElement(
      'span',
      { className: 'private-tag__content-wrapper' },
      truncatedChildren
    );
  },
  render: function render() {
    var _props = this.props,
        _avatar = _props._avatar,
        _bordered = _props._bordered,
        children = _props.children,
        className = _props.className,
        closeable = _props.closeable,
        href = _props.href,
        inline = _props.inline,
        multiline = _props.multiline,
        onClick = _props.onClick,
        __onCloseClick = _props.onCloseClick,
        __onCloseMouseDown = _props._onCloseMouseDown,
        target = _props.target,
        truncateStringProps = _props.truncateStringProps,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['_avatar', '_bordered', 'children', 'className', 'closeable', 'href', 'inline', 'multiline', 'onClick', 'onCloseClick', '_onCloseMouseDown', 'target', 'truncateStringProps', 'use']);

    var renderedCloseButton = this.renderCloseButton({ closeable: closeable });

    var truncatedChildren = multiline ? children : _react2.default.createElement(
      _UITruncateString2.default,
      _extends({ useFlex: true }, truncateStringProps),
      children
    );

    return _react2.default.createElement(
      'span',
      _extends({
        className: this.getClassName({
          _bordered: _bordered,
          className: className,
          closeable: closeable,
          inline: inline,
          use: use
        }),
        tabIndex: closeable ? 0 : undefined
      }, rest),
      _react2.default.createElement(
        'span',
        { className: 'private-tag__flex-wrapper' },
        _avatar,
        this.renderContents({ href: href, target: target, onClick: onClick }, { truncatedChildren: truncatedChildren })
      ),
      renderedCloseButton
    );
  }
});

UITag.STATUS_ALIAS_MAP = STATUS_ALIAS_MAP;

exports.default = UITag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/tag/UITag.js
// module id = 149
// module chunks = 0